export const footerContactStyles = {
  wrapper: {
    margin: {
      mobile: "1.25rem 0",
    },
  },
  heading: {
    color: "white.main",
    fontWeight: "700",
    textTransform: "capitalize",
    opacity: 0.4,
  },
  titleOne: {
    color: "white.main",
    opacity: 0.4,
  },
  titleTwo: {
    fontSize: "1rem",
    lineHeight: "1.625rem",
    color: "white.main",
    opacity: 0.4,
  },
};
